import script from "./AddSpeaker.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSpeaker.vue?vue&type=script&setup=true&lang=js"

import "./AddSpeaker.vue?vue&type=style&index=0&id=54d8af28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d8af28"]])

export default __exports__